import { Message } from '../../Message';

export class Restart extends Message {
	static readonly COMMAND = 'RESTART';
}
